/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useContext, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Formik, Field, FieldArray, FastField } from 'formik';
import * as yup from 'yup';
import Layout from 'components/Layout';
import SubTitle from 'components/SubTitle';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import Label from 'components/Form/Label';
import FileModal from 'components/FileModal';
import TextField from 'components/Form/TextField';

import DialogComponent from 'components/Dialog';

import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext, GlobalOperationContext } from 'store/context';
import { FitinsurAPI ,MessageCenter} from 'utils';
import { Scrollbox, Text, TextArea, Footer, ButtonContent, DialogSelect, DialogCancel, DialogConfirm, ContentAlert, Textarea, DialogRejected, ContentTextarea } from './styles';
import StepNavigation from 'components/StepNavigation/index';
import RenderButtons from 'components/RenderButtons';

export default function WordingApproval(props) {

    const loading = useContext(GlobalLoaderContext);
    const [summary, setSummary] = useState({})
    const [file, setFile] = useState();
    /*     const fitinsurMock = new FitinsurAPIMockup(); */
    const formik = useRef(null);

    const history = useHistory();
    const [nbiMessage, setNbiMessage] = useState("");
    const [historymsg, setHistorymsg] = useState([]);
    const operationContext = useContext(GlobalOperationContext);
    const authContext = useContext(GlobalAuthContext);
    const fitinsur = new FitinsurAPI();
    const mc = new MessageCenter();
    const isClient = authContext.enumProfile == 1 ? true : false;
    //const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOjExMDAsInVzZXJuYW1lIjoicG9jX3RleGVsQGZpdGluc3VyLmNvbS5iciIsInBlcnNvbmlkIjoxMDE3MDMsImZpcnN0TmFtZSI6IlRFWEVMIiwibGFzdE5hbWUiOiJGSU5BTkNFIExJTUlURUQiLCJpZFBlcnNvblJvb3QiOjEwMTcwMywidXNlcmFkbWluIjpmYWxzZSwiZXhwIjoxNTk4MTk0MTkxLCJpYXQiOjE1OTc3NjIxOTF9.v9UjYEeMJw_8vIMowZLAL8Vnh4ovYv86fXSo5sHSKiI";

    const goToLoginPage = () => {
        history.push('/login');
    };

    function testJSON(text) {
        if (typeof text !== "string") {
            return false;
        }
        try {
            JSON.parse(text);
            return true;
        }
        catch (error) {
            return false;
        }
    }

    function handleHistoryMessage() {
        let tempmessage = "";
        if (historymsg?.length >= 1) {
            historymsg.map(
                (message, index) => {
                    const tempMsg = `[${index + 1}] - Name: ${message.userFullName}, Date: ${message.approvalDate}
            ${message.approvalComments}
      
`;
                    tempmessage = (tempmessage + tempMsg);
                }
            )
            return tempmessage;
        }
    };

    useEffect(() => {
        let v = handleHistoryMessage()
        if (formik.current) {
            formik.current?.setFieldValue('dealAnalisysInformation', v)
        }

    }, [historymsg])

    //ToDo Alterar para endPoints do Wording
    function handleFile() {
        fitinsur.setAuthToken(authContext.token);
        fitinsur.requestDocument(props.match.params.idOperation)
            .then(a => {
                console.log(a);
                if (a.status !== 200) {
                    a.json().then(res => {
                        mc.error(res.ret_msg_details);
                        history.goBack();
                        return;
                    })

                } else {

                    a.text().then((response) => {
                        if (testJSON(response)) {
                            response.json().then(res => {
                                mc.error(res.ret_msg_details);
                                history.goBack();
                                return;
                            })
                        } else {
                            setFile(response);
                        }

                    })
                }
            }).catch((error) => {
                mc.error(`There was an error while fetching your data: ${handleFile.name}\n` + error);
                console.error('fitPostDocument - Error:', error);
            });;

    };

    function handleSummary() {
        fitinsur.setAuthToken(authContext.token);
        fitinsur.requestHeaderNbi(props.match.params.idOperation)
            .then(response => response.json()).then(data => {
                console.log("Sumario-> ", data.ret_value)
                if (data.ret_code != 200) {
                    mc.error(data.ret_msg_details);
                    history.goBack();
                    return;
                }
                setSummary({
                  typeOfCover: data.ret_value.typeOfCover,
                  client: data.ret_value.client,
                  obligorCoding: data.ret_value.obligorCoding,
                  responseBy: data.ret_value.responseBy,
                  internalContact: data.ret_value.internalContact,
                  broker: data.ret_value.broker,
                  dealCode: data.ret_value.deal,
                  nmFacility: data.ret_value.nmFacility,
                  nmObligor: data.ret_value.nmObligor,
                  projectName: data.ret_value.projectName
                });
                setHistorymsg(data.ret_value.historical);

                if (formik.current) {
                    formik.current?.setFieldValue('nbiClientSubjectMessage', data.ret_value.nbiClientSubjectMessage || '');
                    formik.current?.setFieldValue('additionalNbiClientSubjectivity', data.ret_value.additionalNbiClientSubjectivity || '');
                }
            })
            .catch((error) => {
                mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
                console.error('fitPostSummary - Error:', error);
            });
    };

    function handleAproval() {
        fitinsur.setAuthToken(authContext.token);
        fitinsur.requestAproveNbiReq(props.match.params.idOperation, userComments)
            .then(response => response.json()).then(resp => {
                if (resp.ret_code === 200) {

                    if (isClient) {
                        history.push(`/list`);
                    } else {
                        history.push(`/broking/send-nbi-cv/${props.match.params.idOperation}`,{idProduct:props.location.state.idProduct});
                    }

                } else {
                    mc.error(resp.ret_msg_details);
                    return;
                }
            })
            .catch((error) => {
                mc.error(`There was an error while fetching your data: ${handleAproval.name}\n` + error);
                console.error('fitPostAproval - Error:', error);
            });
        /* 
                if (isClient) {
                    
        
                } else {
                    fitinsur.requestApprovalNbiCli(props.match.params.idOperation, userComments)
                        .then(response => response.json()).then(resp => {
                            if (resp.ret_code === 200) {
        
                                if (isClient) {
                                    history.push("/list");
                                }
                                history.push(`/broking/select-markets/${props.match.params.idOperation}`);
                            } else {
                                mc.error(resp.ret_msg_details);
                            }
                        })
                        .catch((error) => {
                            mc.error(`There was an error while fetching your data: ${handleAproval.name}\n` + error);
                            console.error('fitPostAproval - Error:', error);
                        });
                } */
    };

    async function handleReject() {
        fitinsur.setAuthToken(authContext.token);
        fitinsur.requestRejectNbiReq(props.match.params.idOperation, userComments)
            .then(x => x.json()).then(resp => {
                if (resp.ret_code === 200) {
                    mc.success("NBI Request Rejected");
                    props.history.push('/list');
                } else {
                    mc.error(resp.ret_msg_details);
                    return;
                }
            }).catch((error) => {
                mc.error(`There was an error while fetching your data: ${handleReject.name}\n` + error);
                console.error('fitPostReject - Error:', error);
            });



    };

    function handleDealDetail(){
        history.push(`/edit-enquirity/${props.match.params.idProduct}/${props.match.params.idOperation}`,{ disabled:true});
    };

    ////////////  Dialog ///////////////// 
    const [userComments, setUserComments] = useState(null);
    const [typeDialog, setTypeDialog] = useState(null);
    const [dialog, setDialog] = useState({
        visible: false,
        title: '',
        icon: 'exclamation',
        args: null
    });

    function handleCancel() {
        setUserComments("");
        setDialog({
            visible: false,
            title: '',
            icon: 'exclamation',
            args: null
        })
    }

    function handleDialog(type) {
        if (type === "Approve") {
            setTypeDialog("Approve");
            setDialog({
                visible: true,
                title: "APPROVE WORDING",
                icon: "TimesCircle",
                args: null,
            })
        } else {
            setTypeDialog("Reject");
            setDialog({
                visible: true,
                title: "REJECT WORDING",
                icon: "TimesCircle",
                args: null,
            })
        }
    };

    ////////////////////////////////////////

    useEffect(() => {

        if (authContext.status !== true) {
            mc.error("User is not authenticated, please Login");
            loading.stop();
            goToLoginPage();
            return;
        }
        else {
            fitinsur.setAuthToken(authContext.token);
            loading.stop();
        };
        /* if (authContext.enumProfile === 1) {
            setIsClient(true);
        } else {
            setIsClient(false);
        } */
        handleFile();
        handleSummary();

    }, []);

    const validation = yup.object().shape({
        /*  nbiClientSubjectMessage: yup.string().required("* Required field"),
         additionalNbiClientSubjectivity: yup.string().required("* Required field"), */
    });

    return (
        <Layout idOperation={props.match?.params?.idOperation} title={summary.projectName ? summary.projectName : summary?.nmObligor ? summary?.nmObligor : "Broking name"} subtitle={summary?.dealCode ? summary?.dealCode : "Deal Code"}>
              <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />

            <Scrollbox>

                <BrokingSummary data={summary} />

                <ContentCard title="APPROVAL WORDING" icon info={{idOperation:props.match?.params?.idOperation || null,idProduct:props.location?.state?.idProduct || null}}>

                    <DialogComponent icon={dialog.icon} title={dialog.title}  show={dialog.visible} setDialog={setDialog}>
                        {typeDialog === 'Approve' ?
                            <ContentTextarea>
                                <p>Deal Analysis information</p>
                                <Textarea value={userComments} onChange={(e) => setUserComments(e.target.value)}></Textarea>
                                <DialogRejected onClick={() => handleCancel()}>CANCEL</DialogRejected>
                                <DialogConfirm onClick={() => handleAproval()}>CONFIRM</DialogConfirm>
                            </ContentTextarea>

                            : typeDialog === 'Reject' ?
                                <ContentTextarea>
                                    <p>Deal Analysis information</p>
                                    <Textarea value={userComments} onChange={(e) => setUserComments(e.target.value)}></Textarea>
                                    <DialogRejected type="submit" onClick={() => handleCancel()}>CANCEL</DialogRejected>
                                    <DialogConfirm type="submit" onClick={() => handleReject()}>CONFIRM</DialogConfirm>
                                </ContentTextarea>
                                : ''
                        }
                    </DialogComponent>{}

                    <Formik
                        innerRef={formik}
                        initialValues={{
                            nbiClientSubjectMessage: '',
                            additionalNbiClientSubjectivity: '',
                            dealAnalisysInformation: ''

                        }}
                        validationSchema={validation}
                        onSubmit={() => { }}
                    >
                        {formikProps => (
                            <Form>
                                <Field
                                    readOnly
                                    label={'Policy Pack Message'}
                                    name={'nbiClientSubjectMessage'}
                                    value={formikProps.values.nbiClientSubjectMessage}
                                    onChange={(e) => formikProps?.setFieldValue('nbiClientSubjectMessage', e)}
                                    component={TextField}
                                />
                               {/*  <Field
                                    readOnly
                                    label={'Additional subjectivities or questions'}
                                    name={'additionalNbiClientSubjectivity'}
                                    value={formikProps.values.additionalNbiClientSubjectivity}
                                    onChange={(e) => formikProps?.setFieldValue('additionalNbiClientSubjectivity', e)}
                                    component={TextField}
                                /> */}
                                <FileModal idOperation={props?.match?.params?.idOperation} file={file} />
                                {!isClient ? (

                                    <Field
                                        readOnly
                                        label={'Deal Analysis Information'}
                                        name={'dealAnalisysInformation'}
                                        value={formikProps.values.dealAnalisysInformation}
                                        onChange={(e) => formikProps?.setFieldValue('dealAnalisysInformation', e)}
                                        component={TextField}
                                    />

                                ) : ''}

                                <ButtonContainer>
                                    <Button forth onClick={() => { }}>&lt; Back</Button>
                                    <RenderButtons idOperation={props.match?.params?.idOperation}>
                                        <ButtonContent>
                                            <Button secundary onClick={(e) => {e.preventDefault(); e.stopPropagation(); handleDialog("Reject") }} style={{ marginLeft: "10px" }}>
                                                REJECT
                                            </Button>
                                            <Button third onClick={(e) => {e.preventDefault(); e.stopPropagation(); handleDealDetail() }} style={{ marginLeft: "10px"}} >
                                                DEAL DETAIL
                                            </Button>
                                            <Button primary onClick={(e) => {e.preventDefault(); e.stopPropagation(); handleDialog("Approve") }} style={{ marginLeft: "10px"}} >
                                                APPROVE
                                            </Button>
                                        </ButtonContent>
                                    </RenderButtons>
                                </ButtonContainer>
                            </Form>
                        )}

                    </Formik>

                    {/* <Label>NBI Message</Label>

                    <TextArea readOnly value={nbiMessage} />

                    <FileModal idOperation={props?.match?.params?.idOperation} file={file} />


                    <Label>Deal Analysis Information</Label>
                    <TextArea
                        readOnly
                        value={handleHistoryMessage()}
                    /> */}


                </ContentCard>
            </Scrollbox>
        </Layout >
    )
}